import AppEntryPreloader from './AppEntryPreloader';

export default AppEntryPreloader;
